<dx-drop-down-box
  [value]="selected"
  [(opened)]="isDropDownBoxOpened"
  [dataSource]="items"
  [showClearButton]="true"
  [showDropDownButton]="true"
  fieldTemplate="fieldTemplate">

  <div *dxTemplate="let data of 'fieldTemplate'">
    <div class="custom-item flex flex-row items-center">
      <span style="width: 18px; height: 18px"
            class="block border border-solid border-gray-700 mx-2"
            [ngStyle]="{backgroundColor: data?.color || '#ffffff'}"></span>
      <dx-text-box
        [value]="data?.path_str"
        placeholder="Sélectionnez une cultutre"
        [readOnly]="true">
      </dx-text-box>
    </div>
  </div>

  <dxo-drop-down-options
    width="100%">
  </dxo-drop-down-options>

  <dxi-button name="clear"></dxi-button>

  <dxi-button name="dropDown"></dxi-button>

  <div *dxTemplate="let data of 'content'">
    <dx-tree-view
      [dataSource]="items"
      [searchEnabled]="true"
      [expandAllEnabled]="true"
      [searchEditorOptions]="{stylingMode: 'underlined'}"
      searchMode="contains"
      dataStructure="plain"
      [rootValue]="null"
      keyExpr="id"
      parentIdExpr="parent_id"
      selectionMode="single"
      displayExpr="name"
      [selectByClick]="true"
      showCheckBoxesMode="none"
      itemTemplate="itemTemplate"
      (onContentReady)="$event.component.selectItem(selected)"
      (onItemSelectionChanged)="onItemSelectionChanged($event)">
      <div *dxTemplate="let itemObj of 'itemTemplate'">
        <div class="flex flex-row items-center">
          <span style="width: 18px; height: 18px" class="block border border-solid border-gray-300 mx-2"
                [ngStyle]="{backgroundColor: itemObj.color || '#ffffff'}"></span>
          <span class="block mr-2 px-2">{{itemObj.name}} </span>
        </div>
      </div>
    </dx-tree-view>
  </div>

</dx-drop-down-box>
